import PropTypes  from 'prop-types'
import React      from 'react'
import { Route  } from 'react-router-dom'
import { Navbar } from 'react-bootstrap'

import { NavLink } from 'alto-react-components/lib/components'
import { profile } from 'alto-react-client-auth/lib/routes'

import { menuSetting } from './settings'
import { menu, canteenManagement, terminalManagement, courseGroupManagement, \
         courseManagement, mealManagement, orderManagement, \
         canteenLogin, webLogin, terminalLogin } from './routes'
import { Menu, CanteenSelection, CanteenProfile, CanteenLogin, WebLogin, TerminalLogin, \
         CanteenManagement, TerminalManagement, CourseGroupManagement,  \
         CourseManagement, MealManagement, OrderManagement } from './components'

export * from './routes'

route = (path, component, options = {}) ->
  <Route key={path} path={path} component={component} {...options} />

export canOrderMeals = (settings, auth = null) ->
  menuSetting(settings).enabled and
    (not auth or not auth.isLoggedIn or auth.havePermission('order_meals'))

export defaultClientRoute = (settings, auth) ->
  canOrderMeals(settings, auth) and menu

export defaultLoggedOutRoute = (settings) ->
  canOrderMeals(settings) and menu

export adminRoutes = ->
  [
    route(canteenManagement,     CanteenManagement),
    route(terminalManagement,    TerminalManagement),
    route(courseGroupManagement, CourseGroupManagement),
    route(courseManagement,      CourseManagement),
    route(mealManagement,        MealManagement),
    route(orderManagement,       OrderManagement)
  ]

export clientRoutes = (settings, auth = null) ->
  routes  = [route(profile, CanteenProfile)]

  routes.push(route(menu, Menu)) if canOrderMeals(settings, auth)

  routes

export loggedOutRoutes = (settings) ->
  routes = [
    route(canteenLogin,  CanteenLogin, exact: true),
    route(webLogin,      WebLogin),
    route(terminalLogin, TerminalLogin)
  ]

  routes.push(route(menu, Menu)) if canOrderMeals(settings)

  routes

export MenuNavLink = ({ children }, { settings, auth }) ->
  if canOrderMeals(settings, auth) then <NavLink to={menu}>{children}</NavLink> else null

export CanteenSelectionNavbarForm = (_, { settings, auth }) ->
  if canOrderMeals(settings, auth)
    <Navbar.Form pullLeft className='canteen-selection'><CanteenSelection /></Navbar.Form>
  else
    null

MenuNavLink.contextTypes                = { settings: PropTypes.object, auth: PropTypes.object }
CanteenSelectionNavbarForm.contextTypes = { settings: PropTypes.object, auth: PropTypes.object }
